<template>
	<common-card class="omapi-personalization__rules">
		<personalization-category
			v-for="category in categoriesToShow"
			:key="category.slug"
			:search="search"
			:category="category"
			:rules="rulesToShow(category.slug)"
			@clearSearch="$emit('clearSearch')"
		/>
	</common-card>
</template>

<script>
import { appData } from '@/utils';

export default {
	props: {
		categories: {
			type: Array,
			required: true,
		},
		filter: {
			type: String,
			default: 'popular',
		},
		search: {
			type: String,
			default: '',
		},
	},
	computed: {
		rules() {
			const d = appData.get('rulesetData');
			return [...d.rules, ...d.wooCommerceRules];
		},
		categoriesToShow() {
			if (this.search) {
				return [
					{
						slug: 'search',
						displayName: `Search Results for &lsquo;${this.search}&rsquo;`,
						order: 1,
					},
				];
			}

			if (this.filter) {
				return this.categories.filter((cat) => this.filter === cat.slug);
			}

			// If no search or filter, show all the categories on the page
			return this.categories;
		},
	},
	methods: {
		rulesToShow(slug) {
			return this.search ? this.searchRules() : this.filteredRules(slug);
		},
		filteredRules(filter) {
			return filter ? this.rules.filter((r) => r.ruleType.includes(filter)) : this.rules;
		},
		searchRules() {
			return appData.get('rulesetData').searchItems(this.search, this.rules);
		},
	},
};
</script>
